import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-male" }, null, -1)
const _hoisted_2 = { class: "el-form-item__label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user" }, null, -1)
const _hoisted_4 = { class: "el-form-item__label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user" }, null, -1)
const _hoisted_6 = { class: "el-form-item__label" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-tie" }, null, -1)
const _hoisted_8 = { class: "el-form-item__label" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-tag" }, null, -1)
const _hoisted_10 = { class: "el-form-item__label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-envelope" }, null, -1)
const _hoisted_12 = { class: "el-form-item__label" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-building" }, null, -1)
const _hoisted_14 = { class: "el-form-item__label" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-tie" }, null, -1)
const _hoisted_16 = { class: "el-form-item__label" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-phone" }, null, -1)
const _hoisted_18 = { class: "el-form-item__label" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-mobile" }, null, -1)
const _hoisted_20 = { class: "el-form-item__label" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-map-marker-alt" }, null, -1)
const _hoisted_22 = { class: "el-form-item__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_crm_reference_data_select = _resolveComponent("crm-reference-data-select")!
  const _component_crm_account_select = _resolveComponent("crm-account-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_crm_user_select = _resolveComponent("crm-user-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "formComponent",
            rules: _ctx.rules,
            model: _ctx.form,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "title" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("ContactCreation.TitleLabel")), 1),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                    class: "form-item-content",
                    placeholder: _ctx.$t('ContactCreation.TitlePlaceholder')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (t) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: t,
                          value: t,
                          label: _ctx.$t('ContactTitle.ContactTitle_' + t)
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "lastName" }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("ContactCreation.LastNameLabel")), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lastName) = $event)),
                    name: "search"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "firstName" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("ContactCreation.FirstNameLabel")), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.firstName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.firstName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "position" }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("ContactCreation.PositionLabel")), 1),
                  _createVNode(_component_el_autocomplete, {
                    modelValue: _ctx.form.position,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.position) = $event)),
                    class: "form-item-content",
                    "fetch-suggestions": _ctx.searchPositions
                  }, null, 8, ["modelValue", "fetch-suggestions"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "personaId" }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("ContactCreation.PersonaLabel")), 1),
                  _createVNode(_component_crm_reference_data_select, {
                    modelValue: _ctx.form.personaId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.personaId) = $event)),
                    class: "form-item-content",
                    placeholder: _ctx.$t('ContactCreation.PersonaPlaceholder'),
                    "reference-data": _ctx.personae
                  }, null, 8, ["modelValue", "placeholder", "reference-data"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "email" }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("ContactCreation.EmailLabel")), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.email,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.email) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.accountVisible)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    prop: "accountId"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("ContactCreation.AccountLabel")), 1),
                      _createVNode(_component_el_row, { class: "form-item-content row-container" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: _ctx.hasAccountCreationPermission ? 22 : 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_crm_account_select, {
                                modelValue: _ctx.form.accountId,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.accountId) = $event)),
                                onChange: _ctx.accountChanged
                              }, null, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }, 8, ["span"]),
                          (_ctx.hasAccountCreationPermission)
                            ? (_openBlock(), _createBlock(_component_el_col, {
                                key: 0,
                                span: 2,
                                class: "add-button"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("i", {
                                    class: "far fa-plus",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createNewAccount()))
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, { prop: "contactManagerId" }, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("ContactCreation.ManagerLabel")), 1),
                  _createVNode(_component_crm_user_select, {
                    modelValue: _ctx.form.contactManagerId,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.contactManagerId) = $event)),
                    class: "form-item-content",
                    "seller-only": true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "phone" }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("ContactCreation.OfficePhoneLabel")), 1),
                  _createVNode(_component_el_autocomplete, {
                    modelValue: _ctx.form.phone,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.phone) = $event)),
                    class: "form-item-content",
                    "fetch-suggestions": _ctx.searchOtherPhones
                  }, null, 8, ["modelValue", "fetch-suggestions"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "mobile" }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("ContactCreation.MobilePhoneLabel")), 1),
                  _createVNode(_component_el_autocomplete, {
                    modelValue: _ctx.form.mobile,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.mobile) = $event)),
                    class: "form-item-content",
                    "fetch-suggestions": _ctx.searchMobilePhones
                  }, null, 8, ["modelValue", "fetch-suggestions"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "address" }, {
                default: _withCtx(() => [
                  _hoisted_21,
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("ContactCreation.AddressLabel")), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.address,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.address) = $event)),
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}